// extracted by mini-css-extract-plugin
module.exports = {"footer":"confirmStatusAlert_footer__1qfgH"};